// src/components/reviews/components/GBPConnectionGate.jsx
import React from 'react';
import { Star, CheckCircle2, Settings, AlertCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

// shadcn components
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../ui/card';
import { Button } from '../../ui/button';
import { Alert, AlertDescription } from '../../ui/alert';

/**
 * Connection Gate - Shows when user hasn't connected Google Business Profile
 * Prompts user to go to settings to connect
 */
const GBPConnectionGate = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-3xl mx-auto">
      <Alert className="mb-6">
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>
          Connect your Google Business Profile to manage reviews from this dashboard
        </AlertDescription>
      </Alert>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Star className="h-6 w-6 text-yellow-500" />
            Google Business Profile Not Connected
          </CardTitle>
          <CardDescription>
            Connect your Google Business Profile to start managing reviews
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          {/* Benefits */}
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <CheckCircle2 className="h-5 w-5 text-green-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium">Reply to customer reviews</p>
                <p className="text-sm text-gray-600">Respond to Google reviews directly from your dashboard</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <CheckCircle2 className="h-5 w-5 text-green-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium">Track review sentiment</p>
                <p className="text-sm text-gray-600">Monitor your ratings and customer feedback over time</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <CheckCircle2 className="h-5 w-5 text-green-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium">Send automated review requests</p>
                <p className="text-sm text-gray-600">Generate review links for email and SMS campaigns</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <CheckCircle2 className="h-5 w-5 text-green-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium">Manage multiple locations</p>
                <p className="text-sm text-gray-600">Handle reviews for all your business locations</p>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <Button
            onClick={() => navigate('/configuration/business?section=integrations')}
            size="lg"
            className="w-full"
          >
            <Settings className="mr-2 h-5 w-5" />
            Go to Settings to Connect
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default GBPConnectionGate;
